import React from 'react';
import Input, { IProps, IMaskedFieldProps } from 'shared/Inputs/Input';
import './_FormInputNewUi.scss';

const FormInputNewUi: React.FC<IProps & IMaskedFieldProps> = ({ field, form, ...props }) => {
  const { name } = field;
  const { placeholder, mask, showMask = false, handleBlur, readOnly, disabled } = props as any;

  return (
    <div className="form__wrapper_newUi inline">
      <div className="form-input-inline">
        <div className="row">
          <Input
            {...props}
            id={name}
            {...field}
            field={field}
            className="form__input  form__input--row"
            placeholder={placeholder}
            mask={mask}
            fieldName={field.name}
            form={form}
            showMask={showMask}
            handleBlur={handleBlur}
            readOnly={readOnly}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

export default FormInputNewUi;
